import { Injectable, inject } from '@angular/core';
import { TslApiService, TslSessionService } from 'projects/aztalena-core/src/public-api';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UserInfo } from 'src/app/user-info';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  private api = inject(TslApiService);
  private session = inject(TslSessionService);

  private userInfoRelay = new BehaviorSubject<UserInfo>(undefined);

  constructor() {
    this.session.isSignedInObservable.subscribe((isSignedIn) => {
      if (isSignedIn) {
        this.updateUserInfo();
      } else {
        this.userInfoRelay.next(undefined);
      }
    });
  }

  getUserInfo(): Observable<UserInfo> {
    if (!this.session.isSignedIn) {
      return of(undefined);
    }
    return this.userInfoRelay.pipe(filter((userInfo) => userInfo !== undefined));
  }

  private updateUserInfo(): void {
    this.getProfile().subscribe((userInfo) => {
      this.userInfoRelay.next(userInfo);
    });
  }

  private getProfile(): Observable<UserInfo> {
    return this.api.get('user/profile');
  }
}
